import { useTranslation } from 'react-i18next'

import Button, { ButtonType } from '../../../Button'
import { FormikField, FormikForm } from '../../../Formik'
import { InputField, PasswordInput } from '../../../Input'
import {
  INTEGRATIONS_FORM_FIELD,
  INTEGRATIONS_FORM_INITIAL_VALUES,
  QA_NAME_INTEGRATIONS_CONNECT,
  QA_NAME_INTEGRATIONS_CONNECT_CANCEL,
} from '../RentalPortalIntegrations.constants'

import { getIntegrationsConnectFormSchema } from './IntegrationsConnectForm.utils'

import * as styles from './IntegrationsConnectForm.module.css'

function IntegrationsConnectForm({ isSaving, onCancel, onSubmit }) {
  const { t } = useTranslation()

  return (
    <FormikForm
      formProps={{ className: styles.IntegrationsConnectForm }}
      initialValues={INTEGRATIONS_FORM_INITIAL_VALUES}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={getIntegrationsConnectFormSchema()}
      onSubmit={onSubmit}
    >
      <FormikField
        Component={InputField}
        fieldComponentProps={{
          label: t('RentalPortal.IntegrationsFormHostLabelKey'),
          required: true,
        }}
        name={INTEGRATIONS_FORM_FIELD.host}
      />
      <FormikField
        Component={InputField}
        fieldComponentProps={{
          label: t('RentalPortal.IntegrationsFormUsernameLabelKey'),
          required: true,
        }}
        name={INTEGRATIONS_FORM_FIELD.username}
      />
      <FormikField
        Component={PasswordInput}
        fieldComponentProps={{
          info: t('RentalPortal.IntegrationsFormSecretHintKey'),
          label: t('RentalPortal.IntegrationsFormSecretLabelKey'),
          required: true,
        }}
        name={INTEGRATIONS_FORM_FIELD.secret}
      />
      <div className={styles.actions}>
        <Button.Contained
          isLoading={isSaving}
          qaName={QA_NAME_INTEGRATIONS_CONNECT}
          text={t('RentalPortal.IntegrationsConnectBtnKey')}
          type={ButtonType.Submit}
        />
        <Button.Outlined
          qaName={QA_NAME_INTEGRATIONS_CONNECT_CANCEL}
          text={t('Modal.CancelBtnKey')}
          onClick={onCancel}
        />
      </div>
    </FormikForm>
  )
}

export default IntegrationsConnectForm
